export const COMPANY_FILTERS_STORAGE_KEY = "company_list_filters";
export const COMPANY_PAGE_STORAGE_KEY = "company_list_page";
export const COMPANY_DISPLAY_COLUMNS_STORAGE_KEY = "company_display_columns";
export const COMPANY_ADVANCED_FILTERS_STORAGE_KEY = "company_advanced_filters";
export const COMPANY_APPLIED_CONDITION_NAME_STORAGE_KEY = "company_applied_condition_name";
export const COMPANY_APPLIED_CONDITION_ID_STORAGE_KEY = "company_applied_condition_id";
/** Marks that the default condition already seeded this document, so clearing the filter sticks. */
export const COMPANY_DEFAULT_SEEDED_STORAGE_KEY = "company_default_seeded";

export const JOB_COUNT_OPTIONS = [
  { label: "0件", value: "0" },
  { label: "1〜3件", value: "1-3" },
  { label: "4〜9件", value: "4-9" },
  { label: "10件以上", value: "10+" },
];

export const MAX_DISPLAY_JOBS = 5;

export const CLOSED_JOB_STATUS = "closed";
